import apiClient from "@/api/axiosClient";

export interface SignupPayload {
  companyName: string;
  displayName: string;
  email: string;
  password: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  displayName: string;
  tenantName: string;
}

export async function signup(payload: SignupPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/signup", payload);
  return data;
}

export async function login(payload: LoginPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/login", payload);
  return data;
}

/** No credentials - signs into the single seeded, read-only public demo
 * tenant. See DemoReadOnlyMiddleware on the backend for why this carries no
 * real access-control risk despite requiring no password. */
export async function demoLogin(): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/demo-login", {});
  return data;
}

export interface ResetPasswordPayload {
  email: string;
  token: string;
  password: string;
}

export async function forgotPassword(email: string): Promise<void> {
  await apiClient.post("/auth/forgot-password", { email });
}

export async function resetPassword(payload: ResetPasswordPayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/reset-password", payload);
  return data;
}
